import API from 'utils/API'
import {
  USER_REQUEST,
  USER_SUCCESS,
  USER_FAILURE,
  USER_UPDATED,
  USER_DETAIL_SUCCESS,
} from 'constants/ActionTypes'

export const userRequest = () => ({
  type: USER_REQUEST,
})

export const userSuccess = (data, meta) => ({
  type: USER_SUCCESS,
  data,
  meta,
})

export const userFailure = errorMessage => ({
  type: USER_FAILURE,
  errorMessage,
})

export const userUpdate = data => ({
  type: USER_UPDATED,
  data,
})

export const userDetail = data => ({
  type: USER_DETAIL_SUCCESS,
  data,
})

export const fetchUser = params => (
  (dispatch) => {
    dispatch(userRequest())
    const url = `/user/accounts/list${params || ''}`
    return API.get(url).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          dispatch(userSuccess(data, meta))
        } else {
          dispatch(userFailure(meta.message))
        }
      },
    ).catch((err) => {
      dispatch(userFailure(err.message))
    })
  }
)

/* export const fetchDetailUser = id => (
  (dispatch) => {
    dispatch(userRequest())
    const url = `/user/${id}`
    return API.get(url).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          dispatch(userDetail(data))
        } else {
          dispatch(userFailure(meta.message))
        }
      },
    ).catch((err) => {
      dispatch(userFailure(err.message)) // eslint-disable-line no-console
    })
  }
) */

export const fetchDetailUser = id => (
  (dispatch) => {
    dispatch(userRequest())
    const url = `/auth/customer/fetch-user-personal-detail/${id}`
    return API.get(url).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          dispatch(userDetail(data))
        } else {
          dispatch(userFailure(meta.message))
        }
      },
    ).catch((err) => {
      dispatch(userFailure(err.message))
    })
  }
)

export const deleteUser = id => (
  (dispatch) => {
    dispatch(userRequest())

    return API.delete(`/user/${id}`).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          dispatch(userUpdate(data))
        } else {
          dispatch(userFailure(meta.message))
        }
      },
    ).catch((err) => {
      dispatch(userFailure(err.message))
    })
  }
)

export const createUser = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/user', payload).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          resolve(data)
        } else {
          reject(meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const updateUser = (payload, id) => (
  () => new Promise((resolve, reject) => (
    API.put(`/user/${id}`, payload).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          resolve(data)
        } else {
          reject(meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const resendEmail = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/email/resend', payload).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          resolve(data)
        } else {
          reject(meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const updateDateDetail = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/user/update-partial?account_id=${id}`, payload).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          resolve(data)
        } else {
          reject(meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const downloadUserDocument = (id, type) => (
  () => new Promise((resolve, reject) => (
    API.get(`/user/document/${id}/${type}`, { responseType: 'blob' }).then(
      (response) => {
        resolve(response)
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

// Kartu Peserta data for member detail; 404 when account not active yet
export const fetchUserCertificate = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/user/certificate/${id}`).then(
      (response) => {
        const { data } = response
        if (data.meta.status) {
          resolve(data.data)
        } else {
          reject(data.meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const fetchHistoryPoint = (id, params) => (
  () => new Promise((resolve, reject) => (
    API.get(`/user/point/history/${id}${params || ''}`).then(
      (response) => {
        const { data } = response
        if (data.meta.status) {
          resolve(data)
        } else {
          reject(data.meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const exportFile = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/user/accounts/list/export${params || ''}`).then(
      (response) => {
        resolve(response)
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const exportFileHistoryPoint = (id, params) => (
  () => new Promise((resolve, reject) => (
    API.get(`/user/point/history/${id}/export${params || ''}`).then(
      (response) => {
        resolve(response)
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const fetchPakDeDownlineList = (id, params) => (
  () => new Promise((resolve, reject) => (
    API.get(`/cms/pak-d?upline_id=${id}${params || ''}`).then(
      (response) => {
        const { data } = response
        if (data.meta.status) {
          resolve(data)
        } else {
          reject(data.meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)

export const fetchTemankuDownlineList = (id, params) => (
  () => new Promise((resolve, reject) => (
    API.get(`/cms/my-friend?upline_id=${id}${params || ''}`).then(
      (response) => {
        const { data } = response
        if (data.meta.status) {
          resolve(data)
        } else {
          reject(data.meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message)
    })
  ))
)
